import { render, staticRenderFns } from "./quesConfigs.vue?vue&type=template&id=490ac122&"
import script from "./quesConfigs.vue?vue&type=script&lang=js&"
export * from "./quesConfigs.vue?vue&type=script&lang=js&"
import style0 from "./quesConfigs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports